export default "dist/images/block-count-up-plain.02d8990.png";